import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { RoutinesDialogComponent } from '../routines-dialog/routines-dialog.component';
import { Routine } from '../routines.model';


@Component({
  selector: 'app-new-routines-card',
  templateUrl: './new-routines-card.component.html',
  styleUrls: ['./new-routines-card.component.scss']
})
export class NewRoutinesCardComponent implements OnInit {
  @Output() action: EventEmitter<Routine> = new EventEmitter<Routine>();

  dialogRef: MatDialogRef<RoutinesDialogComponent>;

  
  constructor(public dialog: MatDialog) { }

  ngOnInit() {
  
  }
  newRoutine(){
  
    this.dialogRef = this.dialog.open(RoutinesDialogComponent, {
      data: {
        type: "New",
        name: "",
        devices: []
      },
      autoFocus: false,
      panelClass: 'inputPopup'
    });

    this.dialogRef.componentInstance.create_action.subscribe(update => {
      if (update) {
        this.action.emit(update);
      }
    });
}
}



// WEBPACK FOOTER //
// ./src/app/entities/routines/new-routines-card/new-routines-card.component.ts